var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOriginator = function SvgOriginator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -12,
    y1: 116.4,
    x2: 113,
    y2: -31.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 70.2,
    y1: 185.8,
    x2: 195.2,
    y2: 37.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 36.7,
    y1: 157.5,
    x2: 161.7,
    y2: 9.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 44.8,
    y1: 164.3,
    x2: 169.8,
    y2: 16.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 52.8,
    y1: 171.2,
    x2: 177.8,
    y2: 23.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 29.1,
    y1: 151.1,
    x2: 154.1,
    y2: 3.1,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.4,13.5h-24.2c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h24.2c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.5,180.3h-4.4c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h4.4c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.6,73.8h58.8c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1h-58.8c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.5,84h-81c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h81c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.4,100.4h-58.8c-1.7,0-3.1,1.4-3.1,3.1s1.4,3.1,3.1,3.1h58.8c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172,29.6c-11.5,0-21,8.6-22.5,19.8h-10.3V15.6c0-8.6-7-15.6-15.6-15.6H20.9C12.3,0,5.3,7,5.3,15.6v154.3h0v14.5c0,8.6,7,15.6,15.6,15.6h102.6c8.6,0,15.6-7,15.6-15.6v-14.4h0v-44.9h14.1c9,0,16.2-7.3,16.2-16.2v-33.9c.8,0,1.7.1,2.5.1,12.5,0,22.6-10.2,22.7-22.7,0,0,0,0,0,0,0-12.5-10.2-22.7-22.7-22.7ZM11.6,15.6c0-5.2,4.2-9.4,9.4-9.4h102.6c5.2,0,9.4,4.2,9.4,9.4v11.3H11.6v-11.3ZM123.6,193.7H20.9c-5.2,0-9.4-4.2-9.4-9.4v-11.3h121.4v11.3c0,5.2-4.2,9.4-9.4,9.4ZM132.9,166.8H11.6V33.2h121.4v16.2h-66.3c-9,0-16.2,7.3-16.2,16.2v43.1c0,9,7.3,16.2,16.2,16.2h4.4c1.1,0,2.1.6,2.7,1.5l8.7,14.2c1.8,2.8,4.8,4.4,8.1,4.3,3.2,0,6.1-1.7,7.8-4.3l8.7-14.2c.6-.9,1.6-1.5,2.6-1.5h23.2v41.8ZM163.2,108.8c0,5.5-4.5,10-10,10h-43.5c-3.2,0-6.3,1.7-8,4.4l-8.7,14.2c-.6.9-1.6,1.5-2.6,1.5-1.1,0-2.1-.6-2.7-1.5l-8.7-14.1c-1.7-2.8-4.7-4.5-8-4.5h-4.4s0,0-.1,0c-5.5,0-9.9-4.6-9.8-10.1v-43c0-5.5,4.5-10,10-10h82.9c1.2,8,6.5,14.6,13.7,17.6v35.5ZM188.4,52.4c0,9.1-7.4,16.4-16.5,16.4-8.9,0-16.1-7.1-16.4-15.9,0-.1,0-.2,0-.3s0-.3,0-.4c.1-9,7.4-16.3,16.5-16.2h0c9,.2,16.3,7.4,16.4,16.4,0,0,0,0,0,0Z"
  })));
};
export default SvgOriginator;